import './scripts/common';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

// Todo: Add page specific JS here e.g:
import * as lightbox from '@elements/lightbox';
lightbox.init({
        // plugins: ['zoom', 'video'],
        // zoom: true,
        // video: true,
        mobileSettings: {
            controls: true
        }
    }
);

import * as dateInput from "@elements/date-input";
dateInput.init();

import * as datepicker from "@elements/datepicker";
datepicker.init();

import * as collectFormdata from "./scripts/collect-formdata";
collectFormdata.init();

import * as collectFormdataCart from "./scripts/collect-formdata-cart";
collectFormdataCart.init();

import * as uncheckInput from "./scripts/uncheck-input";
uncheckInput.init();

import * as toggleForm from "./scripts/toggle-form";
toggleForm.init();

import * as editAddress from "./scripts/edit-address";
editAddress.init();

import * as svgComponents from "./scripts/svg-components";
svgComponents.init();

import * as dynamicModalParams from "./scripts/dynamic-modal-params";
dynamicModalParams.init();

import * as toggleAccessory from "./scripts/toggle-accessory";
toggleAccessory.init();

import * as returnOrder from "./scripts/return-order";
returnOrder.init();

import * as returnForm from "./scripts/return-form";
returnForm.init();

import * as systemfinder from "./scripts/systemfinder";
systemfinder.init();

import * as countCharacters from "./scripts/count-characters";
countCharacters.init();

import * as statistics from "./scripts/statistics";
statistics.init();

import * as barCharts from "./scripts/bar-charts";
barCharts.init();

import * as ajaxLoadMore from "./scripts/ajax-load-more";
ajaxLoadMore.init();

import * as ajaxFileUpload from "./scripts/ajax-file-upload";
ajaxFileUpload.init();

import * as orderRequest from "./scripts/order-request";
orderRequest.init();

import * as orderProbability from "./scripts/order-probability";
orderProbability.init();

import * as editData from "./scripts/edit-data";
editData.init();

import * as numberFormat from "./scripts/number-format";
numberFormat.init();

import * as moveRow from "./scripts/move-row";
moveRow.init();

import * as quickCapture from "./scripts/quick-capture";
quickCapture.init();

import * as addRow from "./scripts/add-row";
addRow.init();

import * as offerTool from "./scripts/offertool";
offerTool.init();

import * as rayEditor from "./scripts/ray-editor";
rayEditor.init();
